import httpManager from "@/app/shared/utils/httpManager";

export async function createQueue(body) {
  const url = `/queues/`;
  const response = await httpManager.post(url, body);
  return response?.data;
}
